var map = {
	"./admin_settings.png": 1873,
	"./appraisals.png": 1874,
	"./catalog.png": 1875,
	"./catalogWhite.png": 1876,
	"./catalog_orders.png": 1877,
	"./cms.png": 1878,
	"./component-fields/Asset.png": 1879,
	"./component-fields/Blocks.png": 1880,
	"./component-fields/Boolean.png": 1881,
	"./component-fields/Date-time.png": 1882,
	"./component-fields/LInk.png": 1883,
	"./component-fields/Markdown.png": 1884,
	"./component-fields/Multi asset.png": 1885,
	"./component-fields/Multi options.png": 1886,
	"./component-fields/Number.png": 1887,
	"./component-fields/Richtext.png": 1888,
	"./component-fields/Single options.png": 1889,
	"./component-fields/Table.png": 1890,
	"./component-fields/Text area.png": 1891,
	"./component-fields/Text.png": 1892,
	"./components.png": 1893,
	"./configuration.png": 1894,
	"./contents.png": 1895,
	"./crm.png": 1896,
	"./custom_order.png": 1897,
	"./customer_credits.png": 1898,
	"./customer_list.png": 1899,
	"./dashboard.png": 1900,
	"./finance.png": 1901,
	"./home.png": 1902,
	"./integrations.png": 1903,
	"./inventory-transfers.png": 1904,
	"./invoice-list.png": 1905,
	"./layaway.png": 1906,
	"./move.png": 1907,
	"./new_sale.png": 1908,
	"./orders.png": 1909,
	"./outgoing-consignments.png": 1910,
	"./payment-methods/amex.png": 1258,
	"./payment-methods/discover.png": 1257,
	"./payment-methods/mastercard.png": 1256,
	"./payment-methods/visa.png": 1255,
	"./payments.png": 1911,
	"./plus.png": 1390,
	"./register.png": 1912,
	"./repair_center.png": 1913,
	"./reports.png": 1914,
	"./services.png": 1915,
	"./trade_in_center.png": 1916
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1737;